import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        orange: '#DF731C',
        blue: '#2F80C2'
      }
    }
  }
})
